import type { FormEvent } from "react";
import { useObserver, useSubtree } from "subtree.js/react";
import { StoreProfileFields } from "../../../../components/StoreProfileFields";
import { ProfileSectionActions, ProfileSectionState } from "./profile-section-model";

export function ProfileSection() {
  const state = useSubtree(ProfileSectionState);
  const actions = useSubtree(ProfileSectionActions);
  const observer = useObserver();
  const draft = observer.watch(state.draft);
  const errors = observer.watch(state.errors);
  const form = observer.watch(state.form);
  const hostsPage = observer.watch(state.hostsPage);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    void actions.save();
  };

  return (
    <form onSubmit={submit} className="space-y-6">
      {form.error && <p className="note note-danger text-danger">{form.error}</p>}

      <StoreProfileFields
        variant="settings"
        draft={draft}
        errors={errors}
        requireDescription={hostsPage}
        onChange={actions.setField}
      />

      <div className="flex flex-wrap justify-end gap-3">
        <button type="submit" disabled={form.busy} className="btn-primary btn-sm">
          {form.busy ? "Saving…" : "Save changes"}
        </button>
      </div>
    </form>
  );
}
